import { store } from "@src/store";
import { END_POINT } from "@constants/api.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";

const { PROFILE_UPDATE } = END_POINT;

export const profileUpdateApi = async (payload) => {
  return await fetch(`${PROFILE_UPDATE}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data, message: data.message };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return { status: false, message: "Something went wrong, please try again later.", error };
    });
};
